export const flexStyle = {
  display: 'flex',
  marginTop: '15px',
  columnGap: '10px',
};

export const spacedStyle = {
  marginTop: '0px',
  flex: '1',
  maxWidth: '49%',
};

export const linkButtonStyle = {
  'position': 'absolute',
  'right': '0',
  'top': '-26px',
  '&:focus': {
    'box-shadow': 'none',
  },
};
